export const CHANNEL = {
  WEIXIN: 'A',
  WEIBO: 'B',
  TAOBAO: 'C',
  ALIPAY: 'D',
  DING: 'E',
  H5BROWSER: 'F',
  YOUKU: 'G',
  GAODE: 'H',
  PCBROWSER: 'I',
  ALIYUN: 'J',
  QQ: 'K',
  UC: 'L',
};
export const SHARE_TYPE = {
  H5WEIXIN: 'A',
  H5IMAGE: 'B',
  H5COPY: 'C',
  H5APP: 'D',
  H5WEIBO: 'E',
  H5QQ: 'F',
  PCWEIXIN: 'G',
  PCDING: 'H',
  PCCOPY: 'I',
  PCWEIBO: 'J',
  PCQQ: 'K',
  PCIMAGE: 'L',
};

export const APPLIST = [
  {
    id: 'copy',
    type: SHARE_TYPE.H5COPY,
    icon: 'copy',
    name: '复制链接',
  },
  {
    id: 'qq',
    icon: 'qq',
    type: SHARE_TYPE.H5QQ,
    name: 'QQ',
    appId: '4', //qq浏览器下的appId
    ucIosAppId: 'kQQ', //uc浏览器ios系统下的appId
    ucAppId: 'QQ', //uc浏览器下的appId
  },
  {
    id: 'weibo',
    icon: 'weibo',
    name: '微博',
    type: SHARE_TYPE.H5WEIBO,
    appId: '11',
    ucIosAppId: 'kSinaWeibo',
    ucAppId: 'SinaWeibo',
  },
];
export const QQ_SHARE_API = 'mqqapi://share/to_fri?src_type=web&version=1&file_type=news';
export const WEIBO_SHARE_API = 'http://service.weibo.com/share/mobile.php';



// WEBPACK FOOTER //
// ./src/components/share/constant.js